import { render, staticRenderFns } from "./DictionaryCrud.vue?vue&type=template&id=d2b5a32c&"
import script from "./DictionaryCrud.vue?vue&type=script&lang=js&"
export * from "./DictionaryCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports